const storagePrefix = 'app-tickets';

export function prefixKey(key) {
    return `${storagePrefix}:${key}`;
}

function getData(key, defaultValue) {
    const value = window.localStorage.getItem(prefixKey(key));

    if (value) {
        return JSON.parse(value);
    }

    return defaultValue;
}

function removeData(key) {
    window.localStorage.removeItem(prefixKey(key));
}

function setData(key, value) {
    try {
        return window.localStorage.setItem(prefixKey(key), JSON.stringify(value));
    } catch (error) {
        const otherError = !(error instanceof DOMException || error.message.indexOf('QuotaExceededError'));
        if (otherError) {
            throw error;
        }
    }

    return undefined;
}

function dispatchStorageEvent(key, value) {
    const oldValue = getData(key);
    const newValue = JSON.stringify(value);

    const event = new StorageEvent('storage', {
        key: prefixKey(key),
        oldValue,
        newValue,
    });
    window.dispatchEvent(event);
}

function hasData(key) {
    return Object.prototype.hasOwnProperty.call(window.localStorage, prefixKey(key));
}

export default {
    getData,
    setData,
    hasData,
    removeData,
    dispatchStorageEvent,
}
